"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToQueue = void 0;
var React = require("react");
var Icon_styled_1 = require("../Icon.styled");
var common_styles_1 = require("@next-components/common-styles");
exports.AddToQueue = function (props) { return (React.createElement(Icon_styled_1.StyledSvg, { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { fill: props.fill || common_styles_1.black, d: "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z" }))); };
//# sourceMappingURL=addtoqueue.js.map